import * as React from 'react';
export default function getExtraFooter(prefixCls, mode, renderExtraFooter) {
    if (!renderExtraFooter) {
        return null;
    }
    return (<div className={`${prefixCls}-footer-extra`}>{renderExtraFooter(mode)}</div>);
}
